import { useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary } from "@hawkins/components";

import { useLocaleIcons } from '../hooks/useLocaleIcons';
import { Colors } from "@hawkins/variables";
import { prepareContentfulHtml } from '@lep-shared/richTextHtml';

type AccordionProps = {
  title: string;
  content: string;
};

export default function EducateAccordion({ title, content }: AccordionProps) {
  const [expanded, setExpanded] = useState(false);
  const { IconChevronRight } = useLocaleIcons();

  return (
      <Accordion
        data-testid="educate-accordion"
        expanded={expanded}
        onChange={(_, expanded) => {
          setExpanded(expanded);
        }}
        style={{ backgroundColor: Colors.White }}
      >
        <AccordionSummary
          aria-controls="panel2-content"
          id="panel2-header"
          title={title}
          toggleIcon={<IconChevronRight />}
        />
        <AccordionDetails>
          <div
            dangerouslySetInnerHTML={{
              __html: prepareContentfulHtml(content),
            }}
          ></div>
        </AccordionDetails>
      </Accordion>
  );
}
